<template>
  <div class="product-list">
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item>
          <el-button size="small" type="primary" @click="commentClick">添加应用技术</el-button>
        </el-form-item>
        <el-form-item label="技术名称">
          <el-input size="small" v-model="searchForm.name" placeholder="请输入技术名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column label="商品" width="400px">
            <template slot-scope="scope">
              <div class="product-info">
                <div class="pic"><img v-img-url="scope.row.imagePath" alt=""/></div>
                <div class="info">
                  <div class="name">{{ scope.row.productName }}</div>
                  <div class="price">￥{{ scope.row.productPrice }}</div>
                  <!--                  <div class="name">订单号:{{ scope.row.orderNo }}</div>-->
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="nickname" label="	发布人" width="100"></el-table-column>
          <el-table-column prop="content" label="内容">
            <template slot-scope="scope">
              <p class="ww100 text-ellipsis-2">{{ scope.row.content }}</p>
            </template>
          </el-table-column>
          <el-table-column prop="isPicture" label="图片" width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.isPicture==0">没有</span>
              <span v-else>有</span>
            </template>
          </el-table-column>
          <!--          <el-table-column prop="status" label="评价状态">-->
          <!--            <template slot-scope="scope">-->
          <!--              <span v-if="scope.row.status==0" class="red fb">待审核</span>-->
          <!--              <span v-if="scope.row.status==1" class="green">审核通过</span>-->
          <!--              <span v-if="scope.row.status==2" class="gray9">审核未通过</span>-->
          <!--            </template>-->
          <!--          </el-table-column>-->
          <!--          <el-table-column prop="sort" label="排序" width="100"></el-table-column>-->
          <el-table-column prop="createTime" label="发布时间" width="160"></el-table-column>
          <el-table-column fixed="right" label="操作" width="100">
            <template slot-scope="scope">
              <el-button @click="editClick(scope.row)" type="text" size="small">
                编辑
              </el-button>
              <el-button @click="delClick(scope.row)" type="text" size="small">删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background
                       :current-page="curPage"
                       :page-size="pageSize" layout="total, prev, pager, next, jumper"
                       :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>
    <el-dialog title="添加应用技术" :visible.sync="dialogVisible" @close="dialogFormVisible"
               :close-on-press-escape="false"
               top="5vh">
      <div style="display: block">
        <el-form size="mini" label-position="left" :model="editform" label-width="100px">
          <el-form-item label="商品名称:">
            <p>{{ editform.productName }}</p>
          </el-form-item>
          <el-form-item label="应用标题:">
            <el-input v-model="editform.title"
                      placeholder="请输入技术标题"></el-input>
          </el-form-item>
          <el-form-item label="技术内容:">
            <el-input type="textarea" rows="4" resize="false" v-model="editform.content"
                      placeholder="请输入技术内容"></el-input>
          </el-form-item>
          <el-form-item label="应用图例：">
            <div class="draggable-list">
              <draggable class="wrapper" v-model="editform.imageList">
                <transition-group>
                  <div class="item" v-for="(item, index) in editform.imageList" :key="item">
                    <img v-img-url="item.filePath"/>
                    <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index)"><i
                      class="el-icon-close"></i></a>
                  </div>
                </transition-group>
              </draggable>
              <div class="item img-select" @click="openProductUpload('image', 'imageList')"><i class="el-icon-plus"></i>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="发布人头像：">
            <div style="width: 80px;height: 80px;  overflow: hidden;border: 1px dashed #dddddd;border-radius: 50%;">
              <div class="item img-select"
                   style="width: 80px;height: 80px;display: flex;justify-content: center;align-items: center;"
                   @click="openProductUpload('image', 'header')">
                <i class="el-icon-plus" v-if="!editform.headerPath"></i>
                <img
                  style="max-height: 100%; max-width: 100%;"
                  v-img-url="editform.headerPath" v-if="editform.headerPath"/>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="发布人名称：">
            <el-input style="width: 220px" v-model="editform.publishName" placeholder="请输入发布人名称"></el-input>
          </el-form-item>
          <el-form-item label="发布人性别：">
            <el-radio-group style="width: 220px" v-model="editform.gender">
              <el-radio :label="0">女</el-radio>
              <el-radio :label="1">男</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="发布时间：">
            <el-date-picker
              v-model="editform.createTime"
              value-format="yyyy-MM-dd HH:mm:ss"
              format="yyyy-MM-dd HH:mm:ss"
              type="datetime"
              placeholder="发布时间">
            </el-date-picker>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible=false">取 消</el-button>
        <el-button size="small" type="primary" @click="addComment">确 定</el-button>
      </div>
    </el-dialog>

    <Upload v-if="isProductUpload" :config="config" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">
      上传图片
    </Upload>
  </div>
</template>

<script>
import Upload from '@/components/file/Upload'
import draggable from 'vuedraggable'
import PorductApi from '@/api/product.js'

export default {
  name: 'Technology',
  inject: ['form'],
  components: {
    draggable,
    Upload
  },
  data () {
    return {
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*总条数*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*搜索参数*/
      searchForm: {
        score: 0,
        name: ''
      },
      config: {},
      dialogVisible: false,
      isProductUpload: false,
      file_name: 'image',
      editform: {
        content: '',
        imageList: [],
        productId: 0,
        title: '',
        productName: '',
        score: 10,
        headerPath: '',
        publishName: '',
        gender: '',
        createTime: ''
      },
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      /*获取列表*/
      this.getData()
    },
    /*搜索查询*/
    onSubmit () {
      this.curPage = 1
      this.getData()
    },
    /*选择第几页*/
    handleCurrentChange (val) {
      let self = this
      self.curPage = val
      self.loading = true
      let Params = self.searchForm
      self.getData(Params)
    },

    /*每页多少条*/
    handleSizeChange (val) {
      this.curPage = 1
      this.pageSize = val
      this.getData()
    },

    /*获取列表*/
    getData (param = '') {
      let self = this
      self.loading = true
      let Params = self.searchForm
      Params.pageIndex = self.curPage
      Params.pageSize = self.pageSize
      Params.status = self.status
      if (this.form.model.productId) {
        Params.productId = this.form.model.productId
      }
      PorductApi.getTechnologyList(Params, true).then(res => {
        self.loading = false
        self.tableData = res.data.records
        self.totalDataNumber = res.data.total
      }).catch(error => {
        self.loading = false
      })
    },
    commentClick () {
      let imagePath = this.form.model.image && this.form.model.image.length ? this.form.model.image[0].filePath : ''
      this.editform = {
        content: '',
        imageList: [],
        productId: this.form.model.productId,
        productName: this.form.model.productName || '',
        title: '',
        score: 10,
        headerPath: '',
        publishName: '',
        gender: 0,
        createTime: ''
      }
      this.dialogVisible = true
    },
    editClick (row) {
      let technologyId = row.id
      let imagePath = this.form.model.image && this.form.model.image.length ? this.form.model.image[0].filePath : ''
      PorductApi.getTechnologyDetail({technologyId}, true).then(res => {
        let data = res.data
        this.editform = {
          id: data.id || 0,
          content: data.content || '',
          imageList: data.image || [],
          productId: this.form.model.productId,
          productName: this.form.model.productName || '',
          score: data.score || 10,
          title: data.title || '',
          headerPath: data.headerPath || '',
          publishName: data.publishName || '',
          gender: data.gender || 0,
          createTime: data.createTime || ''
        }
        this.dialogVisible = true
      }).catch(error => {
        console.log(error)
      })


    },
    addComment () {
      let self = this
      let params = {}
      Object.assign(params, this.editform)
      if (this.editform.id) {
        PorductApi.editProductTechnology(params).then(data => {
          self.$message({
            message: '操作成功',
            type: 'success'
          })
          this.getData()
          self.dialogVisible = false
        })
      } else {
        PorductApi.addProductTechnology(params).then(data => {
          self.$message({
            message: '操作成功',
            type: 'success'
          })
          this.getData()
          self.dialogVisible = false
        })
      }
    },

    delClick: function (row) {
      let self = this
      self.$confirm('删除后不可恢复，确认删除该记录吗?', '提示', {
        type: 'warning'
      }).then(() => {
        PorductApi.delTechnology({
          technologyId: row.id
        }).then(data => {
          self.$message({
            message: '删除成功',
            type: 'success'
          })
          self.getData()
        })
      })
    },
    dialogFormVisible (e) {
      this.editform = {
        content: '',
        imageList: [],
        productId: 0,
        productName: '',
        score: 10,
        headerPath: '',
        publishName: '',
        gender: 0,
        createTime: ''
      }
    },
    returnProductImgsFunc (e) {
      if (e != null) {
        // 兼容后端
        if (e.length > 0) {
          if (this.file_name === 'imageList') {
            this.editform.imageList = this.editform.imageList.concat(e)
          } else if (this.file_name === 'header') {
            this.editform.headerPath = e[0].filePath
          }
        }
      }
      this.isProductUpload = false
    },
    /*删除商品图片*/
    deleteImg (index) {
      this.editform.imageList.splice(index, 1)
    },
    /*打开上传图片*/
    openProductUpload: function (file_type, file_name) {
      this.file_name = file_name
      if (this.file_name === 'imageList') {
        this.config = {
          total: 9,
          fileType: file_type
        }
      } else if (this.file_name === 'header') {
        this.config = {
          total: 1,
          fileType: file_type
        }
      }

      this.isProductUpload = true
    },
    getShowCategoryName (list) {
      let text = ''
      if (list && list.length) {
        text = list.map(item => {
          return item.categoryName
        }).join(',')
      }
      return text
    }
  }
}
</script>

<style lang="scss" scoped>
.draggable-list {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/product/product/part/Technology.vue